import {Injectable} from "@angular/core";
import {UiEnumService, UiTranslateLoaderService} from "ui-shared";
import {EnumGender} from "../../../model/enum-gender";
import {BehaviorSubject} from "rxjs";
import { CodeTextService, CodeTextDiscriminatorValues, MasterDataTableNames } from 'humanresources-common-shared';
import {
    PerObjectDefinitionService
} from "../../organization/object-management/object-definition/service/per-object-definition-service";

@Injectable({
    providedIn: 'root',
})
export class PerEntityList {
    entity = [
        {
            entityName: 'PerIdentity',
            showAdvancedSearch: true,
            attributes: [
                {
                    name: 'identificationNumber',
                    type: 'String',
                    comType: 'String',
                    showAdvancedSearch: true,
                    entity: 'String',
                },
                {
                    name: 'name',
                    type: 'String',
                    comType: 'String',
                    showAdvancedSearch: true,
                    entity: 'String',
                },
                {
                    name: 'surname',
                    type: 'String',
                    comType: 'String',
                    showAdvancedSearch: true,
                    entity: 'String',
                },
                {
                    name: 'maidenName',
                    type: 'String',
                    showAdvancedSearch: false,
                    entity: 'String',
                },
                {
                    name: 'fatherName',
                    type: 'String',
                    showAdvancedSearch: false,
                    entity: 'String',
                },
                {
                    name: 'motherName',
                    type: 'String',
                    showAdvancedSearch: false,
                },
                {
                    name: 'birthDate',
                    type: 'date',
                    showAdvancedSearch: false,
                },
                {
                    name: 'placeOfBirth',
                    type: 'String',
                    showAdvancedSearch: false,
                },
                {
                    name: 'gender',
                    type: 'EnumGender',
                    comType: 'category',
                    showAdvancedSearch: true,
                    entity: 'EnumGender',
                    options: {
                        source: this.getGenderList(),
                        label: 'label',
                        value: 'value',
                    },
                },
                {
                    name: 'hrmMaritalStatusUuid',
                    type: 'String',
                    showAdvancedSearch: false,
                },
                {
                    name: 'genCountryId',
                    type: 'category',
                    showAdvancedSearch: false,
                },
                {
                    name: 'genProvinceId',
                    type: 'category',
                    showAdvancedSearch: false,
                },
                {
                    name: 'genSubprovinceId',
                    type: 'category',
                    showAdvancedSearch: false,
                },
                {
                    name: 'subdistrictVillage',
                    type: 'String',
                    showAdvancedSearch: false,
                },
                {
                    name: 'volumeNumber',
                    type: 'String',
                    showAdvancedSearch: false,
                },
                {
                    name: 'familyOrder',
                    type: 'String',
                    showAdvancedSearch: false,
                },
                {
                    name: 'orderNumber',
                    type: 'String',
                    showAdvancedSearch: false,
                },
                {
                    name: 'placeOfIssue',
                    type: 'String',
                    showAdvancedSearch: false,
                },
                {
                    name: 'registrationNumber',
                    type: 'String',
                    showAdvancedSearch: false,
                },
                {
                    name: 'dateOfIssue',
                    type: 'date',
                    showAdvancedSearch: false,
                },
                {
                    name: 'validUntil',
                    type: 'LocalDate',
                    showAdvancedSearch: false,
                },
                {
                    name: 'identitySerial',
                    type: 'String',
                    showAdvancedSearch: false,
                },
                {
                    name: 'identitySerialNumber',
                    type: 'String',
                    showAdvancedSearch: false,
                },
                {
                    name: 'identityStatus',
                    type: 'EnumIdentityStatus',
                    showAdvancedSearch: false,
                },
                {
                    name: 'reasonOfIssue',
                    type: 'CodeTextDiscriminator',
                    showAdvancedSearch: false,
                },
                {
                    name: 'reasonOfIssueId',
                    type: 'number',
                    showAdvancedSearch: false,
                },
                {
                    name: 'status',
                    type: 'category',
                    showAdvancedSearch: false,
                },
                {
                    name: 'bloodType',
                    type: 'category',
                    showAdvancedSearch: false,
                },
                {
                    name: 'integrationGetDate',
                    type: 'LocalDate',
                    showAdvancedSearch: false,
                },
                {
                    name: 'integrationSource',
                    type: 'category',
                    showAdvancedSearch: false,
                },
                {
                    name: 'integrationSourceId',
                    type: 'number',
                    showAdvancedSearch: false,
                },
                {
                    name: 'deathDate',
                    type: 'date',
                    showAdvancedSearch: false,
                },
            ],
        },
        {
            entityName: 'PerMovement',
            showAdvancedSearch: true,
            attributes: [
                {
                    name: 'beginDate',
                    type: 'LocalDate',
                    comType: 'Date',
                    showAdvancedSearch: true,
                    entity: 'LocalDate',
                },
                {
                    name: 'endDate',
                    type: 'LocalDate',
                    comType: 'Date',
                    showAdvancedSearch: true,
                    entity: 'LocalDate',
                },

                {
                    name: 'hrmTypeId',
                    entity: 'Long',
                    type: 'Long',
                    comType: 'category',
                    showAdvancedSearch: true,
                    options: {
                        source: this.codeTextService.hrmTypelookupQueryWithObjectCode(MasterDataTableNames.MOVEMENT),
                        label: 'text',
                        value: 'id',
                    },
                },
                {
                    name: 'kindTypeId',
                    entity: 'Long',
                    type: 'Long',
                    comType: 'category',
                    showAdvancedSearch: true,
                    options: {
                        source: this.codeTextService.lookup(CodeTextDiscriminatorValues.KIND_TYPE),
                        label: 'text',
                        value: 'id',
                    },
                },
                {
                    name: 'serviceReasonId',
                    entity: 'Long',
                    type: 'Long',
                    comType: 'category',
                    showAdvancedSearch: true,
                    options: {
                        source: this.codeTextService.lookup(CodeTextDiscriminatorValues.SERVICE_REASON),
                        label: 'text',
                        value: 'id',
                    },
                },
                {
                    name: 'outgoingInstitution',
                    type: 'String',
                    comType: 'String',
                    showAdvancedSearch: true,
                    entity: 'String',
                },
                {
                    name: 'confirmationDate',
                    type: 'LocalDate',
                    comType: 'Date',
                    showAdvancedSearch: true,
                    entity: 'LocalDate',
                },
                {
                    name: 'confirmationNo',
                    type: 'String',
                    comType: 'String',
                    showAdvancedSearch: true,
                    entity: 'String',
                },

                {
                    name: 'startDate',
                    type: 'LocalDate',
                    comType: 'Date',
                    showAdvancedSearch: true,
                    entity: 'LocalDate',
                },

                {
                    name: 'leavingDate',
                    type: 'LocalDate',
                    comType: 'Date',
                    showAdvancedSearch: true,
                    entity: 'LocalDate',
                },
                {
                    name: 'confirmedBy',
                    type: 'String',
                    comType: 'String',
                    showAdvancedSearch: true,
                    entity: 'String',
                },
                {
                    name: 'employeeLevelId',
                    entity: 'Long',
                    type: 'Long',
                    comType: 'category',
                    showAdvancedSearch: true,
                    options: {
                        source: this.codeTextService.lookup(CodeTextDiscriminatorValues.EMPLOYEE_LEVEL),
                        label: 'text',
                        value: 'id',
                    },
                },
            ],
        },
        {
            entityName: 'PerOrganization',
            showAdvancedSearch: true,
            attributes: [
                {
                    name: 'hrmTypeId',
                    type: 'Long',
                },
                {
                    name: 'hrmPerWorkAreaId',
                    entity: 'Long',
                    type: 'Long',
                    comType: 'category',
                    showAdvancedSearch: true,
                    options: {
                        source: this.getCodeTextObservable(CodeTextDiscriminatorValues.WORK_AREA),
                        label: 'text',
                        value: 'id',
                    },
                },

                {
                    name: 'hrmPerWorkArea',
                    type: 'CodeTextDiscriminator',
                    relationship: 'ManyToOne',
                },
                {
                    name: 'hrmPerWorkSubareaId',
                    entity: 'Long',
                    type: 'Long',
                    comType: 'category',
                    showAdvancedSearch: true,
                    options: {
                        source: this.getCodeTextObservable(CodeTextDiscriminatorValues.WORK_SUBAREA),
                        label: 'text',
                        value: 'id',
                    },
                },
                {
                    name: 'hrmPerWorkSubarea',
                    type: 'PerWorkSubarea',
                    relationship: 'ManyToOne',
                },
                {
                    name: 'hrmPerEmployeeTypeId',
                    entity: 'Long',
                    type: 'Long',
                    comType: 'category',
                    showAdvancedSearch: true,
                    options: {
                        source: this.getCodeTextObservable(CodeTextDiscriminatorValues.EMPLOYEE_TYPE),
                        label: 'text',
                        value: 'id',
                    },
                },
                {
                    name: 'hrmPerEmployeeType',
                    type: 'CodeTextDiscriminator',
                    relationship: 'ManyToOne',
                },
                {
                    name: 'hrmPerEmployeeSubtypeId',
                    entity: 'Long',
                    type: 'Long',
                    comType: 'category',
                    showAdvancedSearch: true,
                    options: {
                        source: this.getCodeTextObservable(CodeTextDiscriminatorValues.EMPLOYEE_SUBTYPE),
                        label: 'text',
                        value: 'id',
                    },
                },
                {
                    name: 'hrmPerEmployeeSubtype',
                    type: 'PerEmployeeSubtype',
                    relationship: 'ManyToOne',
                },
                {
                    name: 'hrmPerServiceClassId',
                    type: 'Long',
                },
                {
                    name: 'hrmPerServiceClass',
                    type: 'CodeTextDiscriminator',
                    relationship: 'ManyToOne',
                },
                {
                    name: 'perStaffClass',
                    type: 'EnumStaffClass',
                },
                {
                    name: 'hrmPayPayrollSwitchUuid',
                    type: 'String',
                },
                {
                    name: 'posHrmPerObjectDef',
                    type: 'PerObjectDefinition',
                    relationship: 'ManyToOne',
                },
                {
                    name: 'posHrmPerObjectDefId',
                    type: 'Long',
                    comType: 'picker',
                    entity: 'Long',
                    pickerType: 'position',
                    pickerData: '',
                    showAdvancedSearch: true,
                },
                {
                    name: 'titleHrmPerObjectDef',
                    type: 'PerObjectDefinition',
                    relationship: 'ManyToOne',
                },
                {
                    name: 'titleHrmPerObjectDefId',
                    type: 'Long',
                    entity: 'Long',
                    comType: 'category',
                    showAdvancedSearch: true,
                    options: {
                        source: this.objectDefinitionService.getTitleList(),
                        label: 'longText',
                        value: 'id',
                    },
                },
                {
                    name: 'cadreHrmPerObjectDef',
                    type: 'PerObjectDefinition',
                    relationship: 'ManyToOne',
                },
                {
                    name: 'cadreHrmPerObjectDefId',
                    type: 'Long',
                },
                {
                    name: 'orgHrmPerObjectDef',
                    type: 'PerObjectDefinition',
                    relationship: 'ManyToOne',
                },
                {
                    name: 'orgHrmPerObjectDefId',
                    type: 'Long',
                    comType: 'picker',
                    entity: 'Long',
                    pickerType: 'organization',
                    pickerData: '',
                    showAdvancedSearch: true,
                },
                {
                    name: 'ParentOrgUnit',
                    entity: 'Long',
                    type: 'Long',
                    comType: 'picker',
                    pickerType: 'organization',
                    pickerData: '',
                    showAdvancedSearch: true,
                },
                {
                    name: 'movement',
                    type: 'PerMovement',
                    relationship: 'OneToOne',
                },
                {
                    name: 'status',
                    type: 'EnumPersonalDataApprovalStatus',
                },
                {
                    name: 'titleDetailId',
                    type: 'Long',
                },
                {
                    name: 'titleDetailType',
                    type: 'CodeTextDiscriminator',
                    relationship: 'ManyToOne',
                },
                {
                    name: 'perOrganizationExt',
                    type: 'PerOrganizationExt',
                    relationship: 'OneToOne',
                },
            ],
        },
        {
            entityName: 'PerOrganizationGeneralInfo',
            showAdvancedSearch: false,
            attributes: [
                {
                    name: 'perObjectDefinition',
                    type: 'PerObjectDefinition',
                    relationship: 'ManyToOne',
                },
                {
                    name: 'perObjectDefinitionId',
                    type: 'Long',
                },
                {
                    name: 'companyId',
                    type: 'Long',
                },
                {
                    name: 'company',
                    type: 'CodeTextDiscriminator',
                    relationship: 'ManyToOne',
                },
                {
                    name: 'managerPerPeople',
                    type: 'PerPeople',
                    relationship: 'ManyToOne',
                },
                {
                    name: 'managerPerPeopleId',
                    type: 'picker',
                    entity: 'Long',
                    pickerData: '',
                    pickerType: 'people',
                },
            ],
        },
        {
            entityName: 'PerPeople',
            showAdvancedSearch: true,
            attributes: [
                {
                    name: 'peopleNum',
                    type: 'number',

                    showAdvancedSearch: false,
                },
                {
                    name: 'perPeopleStatus',
                    type: 'Long',
                    comType: 'category',
                    entity: 'CodeTextDiscriminator',
                    showAdvancedSearch: false,
                    options: {
                        source: this.getCodeTextObservable(CodeTextDiscriminatorValues.PEOPLE_STATUS),
                        label: 'text',
                        value: 'id',
                    },
                },
                {
                    name: 'perPeopleStatusId',
                    type: 'Long',
                    comType: 'category',
                    entity: 'CodeTextDiscriminator',
                    showAdvancedSearch: true,
                    options: {
                        source: this.getCodeTextObservable(CodeTextDiscriminatorValues.PEOPLE_STATUS),
                        label: 'text',
                        value: 'id',
                    },
                },
                {
                    name: 'perIdentityList',
                    type: 'List',
                    showAdvancedSearch: false,
                },
                {
                    name: 'perOrganizationList',
                    type: 'List',
                    showAdvancedSearch: false,
                },
                {
                    name: 'perPeopleRelationList',
                    type: 'List',
                    showAdvancedSearch: false,
                },
                {
                    name: 'perLeaveRequestList',
                    type: 'List',
                    showAdvancedSearch: false,
                },
                {
                    name: 'movementList',
                    type: 'List',
                    showAdvancedSearch: false,
                },
                {
                    name: 'registryNumber',
                    type: 'String',
                    entity: 'String',
                    comType: 'String',
                    showAdvancedSearch: true,
                },
                {
                    name: 'picture',
                    type: 'FileOwnership',
                    relationship: 'OneToOne',
                },
                {
                    name: 'isEmployee',
                    type: 'boolean',
                    showAdvancedSearch: false,
                },
                {
                    name: 'perPeopleExt',
                    type: 'PerPeopleExt',
                    relationship: 'OneToOne',
                    showAdvancedSearch: false,
                },
                {
                    name: 'isActive',
                    type: 'boolean',
                    entity: 'boolean',
                    comType: 'boolean',
                    showAdvancedSearch: true,
                },
                {
                    name: 'startDate',
                    type: 'LocalDate',
                    showAdvancedSearch: false,
                },
                {
                    name: 'applicantNumber',
                    type: 'Long',
                    showAdvancedSearch: false,
                },
            ],
        },
        {
            entityName: 'PositionStaticInfo',
            showAdvancedSearch: false,
            attributes: [
                {
                    name: 'perObjectDefinition',
                    type: 'PerObjectDefinition',
                    relationship: 'ManyToOne',
                },
                {
                    name: 'perObjectDefinitionId',
                    type: 'Long',
                },
                {
                    name: 'perEmployeeTypeUuid',
                    type: 'String',
                },
                {
                    name: 'perEmployeeType',
                    type: 'CodeTextDiscriminator',
                    relationship: 'ManyToOne',
                },
                {
                    name: 'perEmployeeSubTypeUuid',
                    type: 'String',
                },
                {
                    name: 'perEmployeeSubType',
                    type: 'PerEmployeeSubtype',
                    relationship: 'ManyToOne',
                },
                {
                    name: 'perStaffClass',
                    type: 'EnumStaffClass',
                },
                {
                    name: 'managerialPosition',
                    type: 'boolean',
                },
                {
                    name: 'singleIncubentPosition',
                    type: 'boolean',
                },
                {
                    name: 'capacity',
                    type: 'Long',
                },
                {
                    name: 'description',
                    type: 'String',
                },
                {
                    name: 'secret',
                    type: 'Boolean',
                },
                {
                    name: 'estDate',
                    type: 'LocalDate',
                },
                {
                    name: 'positionStaticInfoExt',
                    type: 'PositionStaticInfoExt',
                    relationship: 'OneToOne',
                },
                {
                    name: 'addAdvance',
                    type: 'boolean',
                },
            ],
        },
    ];

    constructor(
        private enumService: UiEnumService,
        private uiTranslateService: UiTranslateLoaderService,
        private codeTextService: CodeTextService,
        private objectDefinitionService: PerObjectDefinitionService,
    ) {}

    getGenderList() {
        let genderList = this.enumService.createDropdownList(
            EnumGender,
            this.uiTranslateService.instant('hrPerIdentity.genders'),
        );
        return new BehaviorSubject<any>(genderList);
    }

    getEntityAttrListForAdvancedSearch() {
        return this.entity.map((item) => ({
            ...item,
            attributes: (item.attributes as Array<any>).filter((x) => x.showAdvancedSearch === true),
        }));
    }
    getCodeTextObservable(discValue) {
        return this.codeTextService.lookup(discValue);
    }
    getEntityListForAdvancedSearch() {
        return this.entity
            .filter((x) => x.showAdvancedSearch === true)
            ?.map((item) => ({
                name: this.uiTranslateService.instant('hrPerPersonnel.detailSearch.' + item.entityName),
                value: item.entityName,
            }));
    }
    findByName(attributeName: String): any {
        let data = this.getEntityAttrListForAdvancedSearch();
        // Loop through each entity
        for (let entity of data) {
            // Search for the attribute by name within the attributes array
            const attribute = entity.attributes.find((attr) => attr.name === attributeName);

            // If the attribute is found, return it
            if (attribute) {
                return { entityName: entity.entityName, attribute };
            }
        }

        // If no attribute is found, return null
        return null;
    }
    findAttributeByNameFlat(attributeName: String) {
        let data = this.getEntityAttrListForAdvancedSearch();
        const allAttributes = data.flatMap((entity) =>
            entity.attributes.map((attr) => ({ entityName: entity.entityName, attribute: attr })),
        );

        return allAttributes.find((item) => item.attribute.name === attributeName) || null;
    }
}
